import {CookiePolicyRedirectESB} from "@next/eventservice"

const redirectESB = new CookiePolicyRedirectESB()

export const PublishCookiePolicyRedirect = () => {
    redirectESB.publish()
}

export const SubscribeCookiePolicyRedirect = (cb: () => void) => {
    return redirectESB.subscribe(cb)
}
